<template>
  <div class="event">
    <mj-event-navigation class="mb-8" />
    <transition
      name="slide-left"
      mode="out-in"
    >
      <keep-alive>
        <router-view :key="$route.fullPath" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import EventNavigation from '@/components/event/EventNavigation.vue';

export default {
  name: 'Event',

  components: {
    'mj-event-navigation': EventNavigation,
  },

  watch: {
    '$route.params.id': {
      immediate: true,
      handler(eventId) {
        if (eventId) {
          this.updateCurrentEventId(eventId);
        }
      },
    },
    '$route.fullPath': {
      handler() {
        this.fetchEvents();
      },
    },
  },

  methods: {
    ...mapMutations(['updateCurrentEventId']),
    ...mapActions(['fetchEvents']),
  },

};

</script>
